export enum ChooseNextAction {
  ContinuedStay = 'Request Additional Days of Care',
  Level = 'Request Level Adjustment',
  WithoutRequest = 'Upload Additional Documents',
}